exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theme--dark.v-sheet[data-v-b54b83d8]{background-color:#ab3b7a;border-color:#ab3b7a}.container[data-v-b54b83d8]{padding:0}", ""]);

// exports
